<template>
  <div class="border-2 flex flex-col bg-white">
    <button class="p-2 w-full" @click="data?.onElementClick">
      {{ data.label }}
    </button>
    <div class="flex items-center justify-center border-t">
      <button
        class="flex items-center justify-center hover:bg-primary-500 hover:text-white p-2"
        @click="openFileDialog()"
      >
        <span class="material-symbols-outlined">image</span>
      </button>
      <button
        @click.stop="data?.onAddElement"
        @dblclick.stop=""
        class="flex items-center justify-center hover:bg-primary-500 hover:text-white p-2"
      >
        <span class="material-symbols-outlined">add</span>
      </button>
      <button
        @click.stop="data?.onIsolateBranch"
        @dblclick.stop=""
        class="flex items-center justify-center hover:bg-primary-500 hover:text-white p-2"
      >
        <span class="material-symbols-outlined">arrow_and_edge</span>
      </button>
    </div>
  </div>
</template>
<script setup lang="ts">
import { type NodeProps } from "@vue-flow/core";
import { useFileDialog } from "@vueuse/core";

const { data } = defineProps<
  NodeProps<{
    label: string;
    onAddElement: () => void;
    onElementClick: () => void;
    onIsolateBranch: () => void;
    onImageLoaded?: (imageFile: File) => void;
  }>
>();

const {
  open: openFileDialog,
  reset,
  onChange,
} = useFileDialog({
  accept: "image/*",
});

onChange((files) => {
  const file = files?.[0];
  if (!file) return;
  data.onImageLoaded?.(file);
  reset();
});
</script>
